import { isEmpty } from 'lodash';
import currentEnrollmentStatusDescription from 'constants/Enrollment/currentEnrollmentStatusDescription';
import Notification from 'interfaces/Notification';
import '../stylesheets/NotificationDetails.scss';

type EnrollmentStatusUpdateProps = {
    notification: Notification;
};

const EnrollmentStatusUpdate = ({
    notification,
}: EnrollmentStatusUpdateProps) => {
    const memberId = notification.actionMetadata?.['MembId'];
    const memberFirstName = notification.actionMetadata?.['FirstNm'];
    const memberLastName = notification.actionMetadata?.['LastNm'];
    const currentEnrollmentStatus =
        notification.actionMetadata?.['CurrentEnrollmentStatus'];
    const termReason = notification.actionMetadata?.['TermReasonDescription'];

    return (
        <div id="notification-details-content">
            <p>
                Enrollment status for member{' '}
                {[memberLastName, memberFirstName].join(', ')}
                {!isEmpty(memberId) ? ` (${memberId})` : ''} was updated to{' '}
                <strong>
                    {currentEnrollmentStatusDescription[
                        currentEnrollmentStatus
                    ] ?? 'N/A'}
                </strong>
                .
            </p>
            {!isEmpty(termReason) && (
                <p>
                    Reason for disenrollment: <strong>{termReason}</strong>
                </p>
            )}
        </div>
    );
};
export default EnrollmentStatusUpdate;
